/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return async function onChange(value, change) {
    if (props.onChange) {
      props.onChange(value)
    }
  }
}
